const isUsingRelationImage = (entity, fetchFromRelation, imageRelation) =>
  entity && fetchFromRelation && imageRelation.length;

export default isUsingRelationImage;
